// src/routes/RequerimientoRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import TraspasoEquiposPage from "../pages/TraspasoEquiposPage";

const TraspasoEquiposRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<TraspasoEquiposPage />} />
    </Routes>
  );
};

export default TraspasoEquiposRoutes;
